/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/MainProvider';
import styles from './live-stream-content.module.scss';

const LiveStreamContent = ({ isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  return (
    <div className={styles.liveStream}>
      <div className={styles.content}>
        <div>
          <LazyImage
            src={
              isStorybook
                ? './football-ball-big.png'
                : '../../../../../images/football-ball-big.png'
            }
            alt="football ball"
            width={80}
            height={80}
          />
        </div>
        <div>
          <h4>
            {translate(translations, 'sports_online_title_football', 'Football online at any time')}
          </h4>
          <p>
            {translate(
              translations,
              'sports_online_content_football',
              'If you love football, as much as we do, then you will not miss a single second of matches with your favorite teams. In the past, you had to be pinned to a TV to watch the matches. But now you have the great freedom, as you can follow the matches online on computer, tablet or smartphone. That way, you are not tied to a place, but can follow your teams anywhere in the world. You create an account with your provider, log in, and then you can choose exactly what you want to see. Easy, smart and fast!'
            )}
          </p>
        </div>
      </div>
      <div className={styles.content}>
        <div>
          <LazyImage
            src={isStorybook ? './tennis-big.png' : '../../../../../images/tennis-big.png'}
            alt="tennis ball"
            width={80}
            height={80}
          />
        </div>
        <div>
          <h4>
            {translate(
              translations,
              'sports_online_title_tennis',
              'Watch tennis on your tablet, computer or smartphone'
            )}
          </h4>
          <p>
            {translate(
              translations,
              'sports_online_content_tennis',
              'There is nothing better than the perfect serve, return or volley at the net. All this and many more frequencies you can follow when you live stream tennis from the absolute world class. Follow the close clashes between world setter Novak Djokovic, gravel king Rafael Nadal, legend Roger Federer, tennis queen Serena Williams, Russian bomber Maria Sharapova and many more. All you need is to create a user with one of the many tennis providers and then you are ready to watch tennis 24/7.'
            )}
          </p>
        </div>
      </div>
      <div className={styles.content}>
        <div>
          <LazyImage
            src={isStorybook ? './handball-big.png' : '../../../../../images/handball-big.png'}
            alt="handball ball"
            width={80}
            height={80}
          />
        </div>
        <div>
          <h4>
            {translate(
              translations,
              'sports_online_title_handball',
              'Stream handball whenever you want'
            )}
          </h4>
          <p>
            {translate(
              translations,
              'sports_online_content_handball',
              'With streaming on your tablet, computer or smartphone, you can always follow the game with the small sticky ball. There are lots of Danes in the strong German 1st Bundesliga, and both FC Barcelona and PSG Handball in Paris are represented by red and white boys. Also follow the domestic league of both men and women as well as the prestigious European tournaments and finals. Create an account with your provider, log in and be ready for input to the line, lobs and shots directly at the intersection online.'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

LiveStreamContent.propTypes = {
  isStorybook: PropTypes.bool,
};

export default LiveStreamContent;
